import script from "./TestDescription.vue?vue&type=script&setup=true&lang=ts"
export * from "./TestDescription.vue?vue&type=script&setup=true&lang=ts"

import "./TestDescription.vue?vue&type=style&index=0&id=4b292ce0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b292ce0"]])

export default __exports__